/**
 * Live session presence for admin stats.
 *
 * Presence is maintained as Redis indexes (not by scanning session keys).
 * Authenticated requests refresh a user's last-activity score at most once
 * per {@link PRESENCE_THROTTLE_SECONDS}.
 */

/** Minimum interval between presence writes for the same user. */
export const PRESENCE_THROTTLE_SECONDS = 60;

/** Window used for the "currently active" admin count. */
export const PRESENCE_ACTIVE_WINDOW_SECONDS = 5 * 60;

export interface ISessionPresenceStats {
    /** Distinct users with a session still within the session TTL. */
    uniqueLoggedInUsers: number;
    /** Distinct users with activity inside {@link activeWindowSeconds}. */
    activeUsers: number;
    /** Live session keys (one user may have several devices). */
    sessionCount: number;
    activeWindowSeconds: number;
}
